import { connect } from 'react-redux';
import View from './ButtonWithLoadingView';
import { isBusySelector } from '../AdvWorkflow/AdvWorkflowSelector';

const mapStateToProps = (state, ownProps) => ({
  isBusy: isBusySelector(state, ownProps),
});

export default connect(mapStateToProps)(View);
